import React from 'react';

const SubtypeIcon = (props) => (
  <svg
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M31 9L16 1 1 9l15 8 15-8z"
    ></path>
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M29 15.01l2 .99-15 8-15-8 2-.99"
    ></path>
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M29 22.01l2 .99-15 8-15-8 2-.99"
    ></path>
  </svg>
);

export default SubtypeIcon;



// WEBPACK FOOTER //
// ./src/icons/SubtypeIcon.jsx